module.exports = " <div class=home _v-487fba47=\"\"> <img class=\"title fadeIn\" src=" + require("../assets/title.png") + " alt=老师好 _v-487fba47=\"\"> <a class=btn v-link=\"{ name: 'road' }\" _v-487fba47=\"\"> <img src=" + require("../assets/btn_bless.png") + " alt=送上祝福 class=btn-bless _v-487fba47=\"\"> </a> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-487fba47!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = 100
// module chunks = 1